import { z } from "zod";

import { campaignSchema } from "../../../../../lib/types/schema/campaign/campaignSchema";
import { communitySchema } from "../../../../../lib/types/schema/community/communitySchema";

export const givingCampaignWithCommunitySchema = z.object({
  campaign: campaignSchema,
  community: communitySchema,
});

export type GivingCampaignWithCommunity = z.infer<
  typeof givingCampaignWithCommunitySchema
>;
